import React from 'react';
import PropTypes from 'prop-types';

import AuthCookie from '../lib/authCookie';
import useUserContext from '../context/user';

// TODO - GLOBAL SETTINGS
const HTTP_CODE = {
  FORBIDDEN: 403,
};

// TODO - GLOBAL SETTINGS
const SIGNOUT_ERROR_CODES = [301, 302, 303, 401, 402];

const withAuth = (Component, SignInComponent) => {
  const WrappedComponent = props => {
    const userContext = useUserContext();

    if (props.reauthenticate || !userContext.accessToken) {
      return <SignInComponent {...props} />;
    }

    return <Component {...props} />;
  };

  WrappedComponent.getInitialProps = async ctx => {
    let props = {};

    if (!ctx.accessToken) {
      return { reauthenticate: true };
    }

    if (ctx.accessToken && Component.getInitialProps) {
      try {
        props = await Component.getInitialProps(ctx);
      } catch (ex) {
        // TODO Error Class with Payload
        if (ex.code === HTTP_CODE.FORBIDDEN) {
          console.log('withAuth.getInitialProps', ex);
          const json = JSON.parse(ex.message);

          const errorCode = parseInt(json.error.code, 10);
          if (SIGNOUT_ERROR_CODES.indexOf(errorCode) >= 0) {
            AuthCookie.destroy(ctx);
            return { reauthenticate: true };
          }
        } else {
          // Rethrow
          throw ex;
        }
      }
    }

    return { ...props, accessToken: ctx.accessToken };
  };

  WrappedComponent.propTypes = {
    reauthenticate: PropTypes.bool,
  };

  return WrappedComponent;
};

export default withAuth;
